import React, { Fragment } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  Link,
  useParams,
  Outlet,
} from "react-router-dom";
import PropTypes from "prop-types";
import Footer from "./footer";
import Overview from "./overview";
import Overviewmobile from "./overview-mobile";
import Navbar from "../components/navbar";
import "./projects.css";

const Projects = (props) => {
  var params = useParams();
  if (!("projectTitle" in params)) {
    //default to one of the titles when no entry has been clicked yet
    params = { projectTitle: "landing" };
  }
  //console.log(params);
				console.log(params.projectTitle)
  return (
    <div className="main-container">
      <div className="archive-navbar-container">
        <Navbar navImgSrc="/feelers/feelerslogo.png"></Navbar>
      </div>
      <div className="projects-container">
			<div className="projects-overview-mobile"> 
					<Overviewmobile data={projectdata2} />
			</div>
        <div className="projects-table-container">
          <table className="projects-table">
            <thead>
              <tr>
                <th className="projects-header date">Date </th>
                <th className="projects-header title">Project Title </th>
                <th className="projects-header category">Category </th>
                <th className="projects-header status">Status </th>
              </tr>
            </thead>
            <tbody>
              {
                //the line below iterates through the 'projectdata' array and creates a table line from each entry in projectdata
                Object.entries(projectdata2).map(([id, entry]) => (
                  <tr key={id}>
                    {/*key is necessary for some reason otherwise React throws a fit*/}
                    <td className="projects-cell-contents">
                      {entry.date ?? "Date"}
                    </td>
                    <td>
                      <NavLink
                        to={`/archive/${id}`}
                        className="projects-cell-contents"
                      >
                        {entry.title}
                      </NavLink>
                    </td>
                    <td className="projects-cell-contents">
                      {entry.category ?? "Category"}
                    </td>
                    <td className="projects-cell-contents">
                      {entry.status ?? "Status"}
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>

        {/* ------------ OVERVIEW STAiRTS HERE --------------- 
			<Outlet> object links to overview.js and is passed the entry and the projectdata2(the big dictionary at the bottom of this file)
			entry for the current projectTitle (ie it gets passed one entry from the dictionary).
			 */}
        <div className="projects-overview">
				{/*<Outlet context={projectdata2[params.projectTitle]} />*/}
				<Outlet context={{'fulldata': projectdata2, 'title': params.projectTitle}} />
        </div>


			  
      </div>
    </div>
  );
};

const projectdata2 = {
  "ground-loops": {
    // <---- this key will be the url. so 'rain-check' will give a url of /archive/rain-check etc
    date: "Jan 2026",
    title: "Ground Loops",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/ground_loops/ground_loops-1.webp",
    image2: "/assets/ground_loops/ground_loops-2.webp",
    image3: "/assets/ground_loops/ground_loops-5.webp",
    image4: "/assets/ground_loops/ground_loops-7.webp",
		  overview: <p><b>Ground Loops</b> is an exhibition and accompanying series of experimental workshops co-presented by Feelers and the School for Poetic Computation as part of Singapore Art Week 2026 and COMMA Creative Arts Festival 2026.<br /><br />

				  Running from 22–31 January 2026, the exhibition features works by bani haykal, Charmaine Poh, Zainab Aliyu, Ong Kian Peng, Neta Bomani, Melanie Hoff and SHRUB. Curated by Celine Wong Katzman, these works intermingle software, dirt, laughter, and pen on paper to suggest possibilities beyond prevailing digital and social codes.<br /><br />

				  Over both weekends, learners are invited to play close to the metal of the machine in three companion workshops. Participants can create browser-based sound works at Tommy Martinez’s The Musical Web: Gestural Instruments, navigate digital and relational consent with Consensual Hacking by Melanie Hoff and compile a compendium of speculative “bug-lore” in Ashley Hi’s Bring Your Own Bug Spray.<br /><br />

				  This programme is supported by the National Arts Council and Potato Productions, and with venue sponsorship by *SCAPE.<br /><br />
</p>, 
  },
  "bangkokabf-2025": {
    // <---- this key will be the url. so 'rain-check' will give a url of /archive/rain-check etc
    date: "Dec 2025",
    title: "Bangkok Art Book Fair 2025",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/bkabf_2025/bkabf-1.webp",
    image2: "/assets/bkabf_2025/bkabf-2.webp",
    image3: "/assets/bkabf_2025/bkabf-3.webp",
    overview: `Feelers boothed at Bangkok Art Book Fair 2025, bringing along original publications and works by Feelers Friends. The team also presented a new iteration of the Writing Machine workshop for OPEN GROUND, a platform exploring new forms of community-driven exchange as part of the Fair. `, 
  },
  "soai-2025-publication": {
    // <---- this key will be the url. so 'rain-check' will give a url of /archive/rain-check etc
    date: "Oct 2025",
    title: "School of Alternate Internets 2025",
    category: "Print",
    status: "Completed",
    image1: "/assets/soai_2025/soai_2025-print-4.webp",
    image2: "/assets/soai_2025/soai_2025-print-3.webp",
    image3: "/assets/soai_2025/soai_2025-print-5.webp",
		  overview: <p><b>The School of Alternate Internets</b> begins from the premise that a different digital world is possible and is, if we know how to look, already in the process of arriving. It offers tools and frameworks to look at technologies we might otherwise take for granted, as a way of supporting sustained curiosity and attention on the question of what it means to be online. <br /><br />

				  Over consecutive Saturdays in June and July, the 2025 edition of the School unfolded as both classroom and playground. Workshops and discussions drew together visual arts, performance, computing, creative writing, and media studies. The result was less a curriculum than a collective rehearsal: a testing ground for new languages, new tactics, and new ways of relating to our digital lives, whether private and public.  <br /><br />

				  This publication documents and expands on these shared experiments through a collection of notes, reflections, and fragments of practice. They not only record what took place, but also offer a modest invitation: to play, to intervene, to withhold, to trespass. To make choices about technology that expand our vision of an autonomous, nourishing Internet.<br /><br /></p>,
  },
  "we-made-this-monster": {
    // <---- this key will be the url. so 'rain-check' will give a url of /archive/rain-check etc
    date: "Oct 2025",
    title: "We Made This Monster",
    category: "Event",
    status: "Completed",
    image1: "",
    overview: `Feelers' Design Lead Azure Chaya spoke on this panel discussion with Isabella Ong and Wong Zi Hao on exploring agency across machines, materials, and nature. Moderated by Dr. Adrian Tan, the discussion took place at Nanyang Academy of Fine Arts on 26 October 2025. `, 
  },
  "feelers-turns-5": {
    // <---- this key will be the url. so 'rain-check' will give a url of /archive/rain-check etc
    date: "Oct 2025",
    title: "Feelers Turns 5",
    category: "Event",
    status: "Completed",
    image1: "/assets/feelers_turns_5/feelers_turns_5-1.webp",
    image2: "/assets/feelers_turns_5/feelers_turns_5-2.webp",
    image3: "/assets/feelers_turns_5/feelers_turns_5-3.webp",
    overview: `Feelers' friends gathered to celebrate five years of Feelers with an afternoon of five-minute presentations on art, tech and everything in between by Joy Wang, Shashvat Shukla, Samira Hassan, Dawn Lim, Ghee, John Chew Geronimo Jr., Andrew Devadason, Chok Sixuan, Kapilan Naidu, Mengju Lin and Tricia Tan. `, 
  },
  "greener-screens-2025": {
    // <---- this key will be the url. so 'rain-check' will give a url of /archive/rain-check etc
    date: "Sep 2025",
    title: "Greener Screens",
    category: "Education",
    status: "Completed",
    image1: "/assets/greener_screens/greener_screens-4.webp",
    image2: "/assets/greener_screens/greener_screens-2.webp",
		  overview: <p>Feelers’ Director and Tech Lead Ashley Hi shared actionable habits participants could incorporate into their personal or work practice for this iteration of the <b>Greener Screens</b> workshop as part of REINVENTION, a programme presented by Singapore Science Park for Singapore Design Week. </p>, 
  },
  "soai-2025": {
    // <---- this key will be the url. so 'rain-check' will give a url of /archive/rain-check etc
    date: "Jul 2025",
    title: "School of Alternate Internets 2025",
    category: "Education",
    status: "Completed",
    image1: "/assets/soai_2025/soai_2025-1.webp",
    image2: "/assets/soai_2025/soai_2025-4.webp",
    image3: "/assets/soai_2025/soai_2025-3.webp",
		  overview: <p>Over four consecutive Saturdays in June/July 2025, Feelers ran the <b>School of Alternate Internets</b> (SoAI), an alt-education programme for critical thinking, doing, and undoing around our shared online landscape. Driven by artistic research, discussion, and hands on activities, sessions included:<br /><br />

				  <b>Day 1: Identity & Community Online</b><br /><br />
				  – <b>Online Only Friends</b> by Raksha Mahtani, a workshop reflecting on the dynamics of online community spaces, where students built a collective resource toolkit for deepening internet-based intimacies.<br />
				  – Becoming Black Box, a workshop by ants chua that draws on surveillance studies, drag, and decolonial theory, to examine our relationships to transparency in a hypersurveilled digital world. <br /><br />

				  <b>Day 2: Making with Machines</b>  <br /><br />
				  – <b>Machine Madlibs</b>, an activity by Kapilan Naidu that offered an alternate perspective to fatalist attitudes toward generative AI, inviting participants to explore the creative possibilities and absurdities of Large Language Models. <br />
				  – <b>Handshake Via Internet</b> by Ashley Hi, a workshop guiding participants through hacking with both physical and digital internet infrastructures to create an interactive glossary of figurative tech terminology.<br /><br />

				  <b>
				  Day 3: The Attention Economy<br /><br />
				  </b>

				  – <b>Programming For Pleasure</b> by Viknesh Kobinathan, an exercise in reclaiming and reconnecting with the visuals that delight us, through curating personal micro-screening programmes.<br />
				  – <b>An Internet Of Our Own</b> by Aly Chandra, where participants examined the origins of the internet’s enshittification in this critical introduction to the corrupted Internet. <br /><br />

				  <b>
				  Day 4: Artificial Intelligence and Closing Symposium<br /><br />
				  </b>

				  – <b>Mutating Intelligence</b> by Johann Yamin looked to media history to understand the systems we have come to understand as Artificial Intelligence, and their entanglements with power.<br />
				  – <b>Symposium</b>: The Symposium opened with casual artist sharings by by Azure Chaya and Bảo Anh Bùi. Participants were invited to close this cycle of the School by sharing what they have worked on throughout the programme. <br />


				 		  </p>, 
  },
  "waiting-to-upload": {
    // <---- this key will be the url. so 'rain-check' will give a url of /archive/rain-check etc
    date: "Mar 2025",
    title: "Waiting To Upload",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "",
		  overview: <p>DAMN! was Cake Theatre's 2025 iteration of Running With Strippers. Part of DAMN!, <b>Waiting To Upload</b> was a community library of books, essays, and zines that with a focus on how art and technology can interact in interdisciplinary and collaborative ways. The collection featured selected titles from the personal collections of DAMN!'s featured artists and original publications by Feelers.</p>, 
  },
  "season-2025-odds-and-ends": {
    date: "Feb 2025",
	title: "Season 2025: Odds and Ends",
    category: "Season",
    status: "Completed",
    image1: "/assets/szn2025_odds_and_ends/szn2025_odds_and_ends-2.webp",
    image2: "/assets/szn2025_odds_and_ends/szn2025_odds_and_ends-1.webp",
    image3: "/assets/szn2025_odds_and_ends/szn2025_odds_and_ends-5.webp",
		  overview: <p><b>Odds & Ends</b> was Feelers' 2025 Season. This season examined trivial pursuits and ephemera, consequence and the inconsequential. Amidst a paradigm of constant innovation and clean solutions, Feelers looked at aftershocks, aftermaths, and the detritus left behind. This season consisted of: <br /><br />

				  <b>Open Ending</b><br />
				  Post Growth SG hosted a Post Growth Circle which segued into a speculative writing workshop hosted by multidisciplinary artist ila. Through theoretical reading and collective storytelling, participants explored alternatives to the status quo of unfettered growth. <br /><br />

				  <b>Delete Party</b><br />
				  In this cosy, after-hours gathering, tabs were closed, desktops were decluttered, and downloads folders were organised. Delete Party was a joyful confrontation with digital detritus where storage space was freed up and archival strategies were shared. <br /><br />


				  <b>Circuits and Transits</b><br />
				  A collaboration between Feelers and Victoria Hertel, Circuits and Transits was a participatory techno-spiritual ritual where discarded electronics were disassembled and repurposed into talismans for wayfinding. <br /><br />

				  <b>How To Go On</b><br />
				  In this panel discussion, a mainstay of Feelers’ Seasons, young arts professionals Jasmine See and Aida Nurellysa Ahmad discussed how they approach programming, producing, and sustaining their practices in the contemporary arts ecosystem. <br /><br />

				  <b>To Dwell A Little Longer</b><br />
				  Teo Xiao Ting’s meditative essay on the afterlives of technical practices, featuring conversations with Sim Lim Tower shopkeepers and the artists whose practices they support.  <br /><br />
		  </p>,
  },
  "rain-check": {
    date: "Jan 2025",
    title: "Rain Check",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/rain_check/rain_check-3.webp",
    image2: "/assets/rain_check/rain_check-2.webp",
    image3: "/assets/rain_check/rain_check-1.webp",
    overview:
			<p><b>Rain Check</b> was a performance installation at SCAPE as part of Comma Fest 2025. In the Rain Check universe, the Cloud has collapsed and internet access is sporadically available, depending on the weather. Sunlight determines whether one can go online, and the monsoon season precipitates a time of digital silence. Through kinetic sculpture and sensor choreography, Feelers explored the role of internet infrastructures in our everyday lives by imagining their intermittent absence. </p>,
  },
  "kl-art-book-fair": {
    date: "Dec 2024",
    title: "Kuala Lumpur Art Book Fair",
    category: "Exhibition / Performance",
    status: "Completed",
    overview: "Feelers visited the Kuala Lumpur Art Book Fair for the first time in 2024, bringing original publications and publications by Feelers Friends Yifan Wang, Hanae Gomez, and Ada Adhiyatma. ",
  },
  "bug-month": {
    date: "Nov 2024",
    title: "Bug Month",
    category: "Education",
    status: "Completed",
	image1: "/assets/bug_month/bug_month-1.webp",
	image2: "/assets/bug_month/bug_month-4.webp",
	image3: "/assets/bug_month/bug_month-3.webp",
		  overview: <p><b>Bug Month</b> was a trio of programmes focusing on technological bugs and dysfunction. <br /><br />

				  <b>Caterfeelers: Build A Bug</b> :<br />
				  In this cosy, intimate workshop, participants learned basic soldering and connecting of wires as they assembled their own electronic jewellery from our product line Caterfeelers. Participants could build either swish (a charm necklace and fidget spinner mini fan) or click-click (a low res camera necklace which came with 3 acrylic filters). Jewellery could also be customised with charms. Caterfeelers was a collaboration between Feelers and Mengju Lin.<br /><br />


				  <b>Debug Ur Darlings: Repair-a-Thon</b> <br />
				  Love is a ritual of repair, and repair, a ritual of love. This repair-a-thon was a gathering for a practice of self-sufficiency, care, and maintenance that resists a culture of disposability and embraces breakdowns as opportunities to learn. Participants brought devices that they wanted to fix rather than throw, and were guided to diagnose and fix their items.<br /><br />

				  <b>Bring Your Own Bug Spray</b><br />
Like a phantom in a machine, a moth caught in a relay, or a cockroach whispering from a telephone, a bug can be a dreadful haunting or a pleasant surprise. Through a series of speculative writing and coding exercises, participants contributed to a compendium of bug lore that documented shared anxieties around the fear of tech and tech failure through the courage of bug spray. Bring Your Own Bug Spray was a response to the exhibition Sorry For The Technical Difficulties, which ran from 8-17 November at Art Outreach.</p>,
  },
  "sgabf-2024": {
    date: "Nov 2024",
    title: "Singapore Art Book Fair 2024",
    category: "Exhibition / Performance",
    status: "Completed",
	image1: "/assets/sgabf_2024/sgabf_2024-1.webp",
	image2: "",
	image3: "",
    overview: "Feelers boothed at Singapore Art Book Fair 2024, bringing original publications and publications by Feelers Friends Yifan Wang, Hanae Gomez, and Ada Adhiyatma. The booth also featured a listening station for Voices In A Room and a Feelers-themed photobooth. ",
  },
  "feeler-turns-4": {
    date: "Oct 2024",
    title: "Feelers Turns 4",
    category: "Event",
    status: "Completed",
	image1: "/assets/feelers_turns_4/feelers_turns_4-1.webp",
	image2: "/assets/feelers_turns_4/feelers_turns_4-2.webp",
	image3: "", 
		  overview: <p>For Feelers' fourth birthday celebrations, friends gathered to party and play. The party featured fortune-telling, DJ sets by Bernice Gaspar and Kapilan Naidu, cocktails by Ashley Hi, food by ants chua, and live-coded visuals with Hydra by Gaetan Boisson. <br /><br />
				  TTRPGs with Feelers, which took place on the same weekend, was a tabletop roleplaying games session held as part of Feelers’ 4th Birthday Celebrations. Attendees played two TTRPGS. First, Apollo 47 Technical Handbook, which invites players to engage in workaday astronaut activities using a simple improvisatory rules set to play in a quiet world of technobabble and the slow progression of science. <br /><br />Second, Move Quietly and Tend Things, a bittersweet utopia story-game about recovery, repair and revelation, set in a derelict Southeast Asian megastructure sometime in the far future.</p>
  },
  "cloud-cryptid": {
    date: "Sep 2024",
    title: "Cloud Cryptid Friendship Society",
    category: "Exhibition / Performance",
    status: "Completed",
	image1: "/assets/ccfs_2024/ccfs_2024-1.webp",
	image2: "",
	image3: "", 
		  overview:<p>Held in conjunction with the SAM series Skill Futures, <b>Cloud Cryptid Friendship Society (CCFS)</b> was an online performance by Feelers. Cloud Cryptids are fictional, mysterious creatures said to cluster around physical internet infrastructure. Audience members sat in on a meeting of the fictional Singapore Chapter of the CCFS, where cryptozoologists presented research they had undertaken to understand the local Cloud Cryptid population. </p>,
  },
		"silent-reading": {
    date: "Jun 2024",
    title: "Silent Reading",
    category: "Event",
    status: "Completed",
    overview: "Silent Reading was a series of weekly drop-in sessions hosted at Stranger Conversations for quiet companionship: with books, with each other, with the clouds, with The Cloud, with friends old and new. "
	},
  "szn-2024-touch-base": {
    date: "May 2024",
    title: "Season 2024: Touch Base",
    category: "Season",
    status: "Completed",
	image1: "/assets/szn2024_touch_base/szn2024_touch_base-2.webp",
	image2: "/assets/szn2024_touch_base/szn2024_touch_base-1.webp",
	image3: "/assets/szn2024_touch_base/szn2024_touch_base-3.webp", 
		  overview: <p><b>Touch Base</b> was Feelers’ 2024 Season, an annual series of interdisciplinary programmes that flow along circuits and fault lines between art and technology. With Touch Base, Feelers explored going back to the body, slowing down to examine the basics of how art and technology interact. This season consisted of: 

Random Access Memory: a movement workshop by Chew Shaw En which explored how an embodied encounter with technology might look and feel. 

Touch_Time (T_T): cosy gatherings where friends came together to play Cards Against Technology, mix kinetic cocktails, and reflect on fears around the future and technology. 

Let Me Show You What I Saw: a workshop which explored technologies of representation in art and culture, held at Art Outreach in collaboration with Open Offering 1 by About To Ask 

Liturgy of the Archipelago: a profile by Sharmini Aphrodite which featured Filipino ambient and internet artist Chia Amisola and Developh. In this editorial, Chia reflected on archipelagic memory and territory, the visibility of technology and labour, ritual and devotion, and folk histories. 

How To Go On: an intimate conversation with School of Altruism and The Slow Press, which explored how each group sustains and endures as an independent collective. </p> 
  },
  performl: {
    date: "Mar 2024",
    title: "perfor.ml",
    category: "Exhibition / Performance",
    status: "Completed",
	image1: "/assets/performl/performl-1.webp",
	image2: "/assets/performl/performl-2.webp",
	image3: "", 
		  overview: <p><b>Through perfor.ml</b>, Feelers investigated the possibility of bringing machine learning into performance—on whose terms, and for what goals?<br /><br />

This iteration of the research process was a performance installation, bringing together human performers and kinetic sculptures on stage to explore systems of maintenance and upkeep in a subsea data centre. </p>  
  },
  pressplay: {
    date: "Jan 2024",
    title: "How To Build A Data Centre (Excerpt)",
    category: "Exhibition / Performance",
    status: "Completed",
	image1: "/assets/pressplay_howtobuild/pressplay_howtobuild-1.webp",
	image2: "",
	image3: "", 
		  overview: <p><b>How To Build A Data Centre (Excerpt)</b> was an installation as part of NLB’s 2024 PRESSPLAY Festival. <br /><br />

<b>In How To Build A Data Centre (Excerpt)</b>, bits of data, compressed and uniformly stored, were represented by two-dimensional image stacks of photographic print. Each successive frame of the kinetic installation carried the suggestion of a stop-motion film, yet no narrative was progressed. The flattening of information and the repetitive excess of time creates an infinite present prolonged into an indefinite future in conflict with everything living, changing, and developing in the world outside. Within this imagined data centre, scarcity becomes abundance.</p>
  },
  sonicality: {
    date: "Dec 2023",
    title: "Sonicality",
    category: "Research / Development",
    status: "Completed",
	image1: "/assets/sonicality/sonicality-1.webp",
		  overview: <p><b>Sonicality</b> was a collaboration with 55 Minutes design studio and Artwave studio to create an interactive microsite that used a 10-question quiz to reveal users’ unique sonic personalities, highlighting how sound influences their emotions and behavior. By engaging with tones, notes, and ambient sounds, users gained a deeper appreciation of the auditory aspects of their identity. 
</p>,
  },
  "soai-lite-2023": {
    date: "Oct 2023",
    title: "School of Alternate Internets 2023 (Lite)",
    category: "Education",
    status: "Completed",
    image1: "/assets/soailite_2023/soailite_2023-1.webp",
    image2: "/assets/soailite_2023/soailite_2023-2.webp",
		  overview: <p><b>The School of Alternate Internets</b> is an alt-educational program by Feelers for critical thinking, doing, and undoing around technology. After an in-person run of the school in July, SOAI Lite was a fully online, modular version of the program, featuring 11 drop-in sessions across 3 days (2, 3 and 7 December). These sessions included: comprehensive introductions to three contested emerging technologies: AI, the Metaverse, and Blockchain, lectures that bring quirky & non-obvious perspectives to technological experiences, and workshops to put these ideas into action, and expand ways of doing, feeling, and thinking about technology beyond its usual language and logic.
</p>,
  },
  totapo: {
    date: "Sep 2023",
    title: "Totapo",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/totapo/totapo-1.webp",
    image2: "/assets/totapo/totapo-2.webp",
    image3: "/assets/totapo/totapo-3.webp",
    overview: `For the first edition of the art x tech residency Totapo, artist Yifan Wang, student Bùi Nguyễn Bao Anh, and technologist Shivang Srivastava invited and hosted the blockchain in their homes. By interacting with their ‘Ether friend’ (an Ethereum node hosted on a Raspberry Pi), the residents aimed to inspire imaginative, caring, and affective ways of understanding the blockchain, as well as other emerging technologies.`,
  },
  "feeler-turns-3": {
    date: "Sep 2023",
    title: "Feelers Turns 3",
    category: "Event",
    status: "Completed",
    image1: "/assets/feelers_turns_3/feelers_turns_3-1.webp",
    image2: "/assets/feelers_turns_3/feelers_turns_3-2.webp",
    image3: "/assets/feelers_turns_3/feelers_turns_3-3.webp",
    overview: `A birthday party to celebrate Feelers' turning 3 years old, featuring kinetic cocktails by Ashley Hi, astrology chart readings by Ang Kia Yee, food by ants chua, and a DJ set by ila. `,
  },
  "the-internet-is-a-thing": {
    date: "Sep 2023",
    title: "The Internet Is a Thing",
    category: "Education",
    status: "Completed",
    image1: "/assets/the_internet_is_a_thing/the_internet_is_a_thing-1.webp",
		  overview: <p><b>The Internet is a Thing</b> is an art and tech workshop inviting participants to assemble a simple toy driven by the artist Chok Si Xuan and the artist collective Feelers. Connecting to the artwork HzHz by Chok Si Xuan, the workshop probes our understanding of various spaces we interact with, and how we perceive and distinguish them. While interacting in a virtual 3D space, The Internet is a Thing highlights how online worlds are dependent on offline infrastructure through an accessible and playful activity. Participants will be introduced to 3D printing through a demonstration by Feelers, and are encouraged to bring home their own 3D-printed toy!</p>,
  },
  "soai-2023": {
    date: "Jul 2023",
    title: "School of Alternate Internets 2023",
    category: "Education",
    status: "Completed",
    image1: "/assets/soai_2023/soai_2023-1.webp",
    image2: "/assets/soai_2023/soai_2023-2.webp",
		  overview: <p> 
				  <b>The School of Alternate Internets (SoAI)</b> is an educational program for critical thinking, doing, and undoing around technology. The inaugural edition of the program in July 2023 sought to bring critical perspectives to three contested technologies: Artificial Intelligence, Blockchain, and the Metaverse. Led by artists Ashley Hi, Johann Yamin and Ang Kia Yee, the program consisted of primers on these technologies and a series of workshops, including: <br /><br />

				  – Johann Yamin and Xafiér Yap's <b>Gaming The Metaverse</b>, which examined emergent online gaming communities, asking would it mean to queer the metaverse, to intercept with and game its logics. <br /> <br />
				  – Ang Kia Yee's <b>Cyber-Sacred Rituals</b>, where participants were invited to consider what it would look like to engage with the sacred and divine in tandem with technology and to see them as intimately connected rather than in opposition, more alike than not.<br /> <br />

				  – Ashley Hi's <b>Low-Tech Web</b>, which examined contemporary fixations on resource-intensive, algorithmically complex intelligences, challenging participants to consider naturally occurring intelligences and what it could look like if we took cues from permaculture practices in our technological practices.<br /> <br />


Having explored the constellation of technologies surrounding Web3, the final day of the School of Alternate Internets gave participants an opportunity to consolidate their learning through a day-long collaborative hackathon, where group came together to write, code, and illustrate gifs to create a Twine experience.<br /> <br />

		  </p>,
  },
  sketch2pigeon: {
    date: "May 2023",
    title: "sketch2pigeon",
    category: "Education",
    status: "Completed",
    image1: "/assets/sketch2pigeon/sketch2pigeon-1.webp",
    image2: "/assets/sketch2pigeon/sketch2pigeon-2.webp",
    image3: "/assets/sketch2pigeon/sketch2pigeon-3.webp",
		  overview: <p><b>sketch2pigeon</b>, run by Feelers' Tech Lead Ashley Hi, was a beginner’s machine learning workshop tracing the history of image-based ML techniques and their interfaces. 

In the 2.5 hour workshop, participants (most with minimal coding experience) learned how to access and make use of existing pre-trained models to create their own unique projects with minimal coding experience, touching on tools such as GANs, Midjourney, DALL-E, and ChatGPT. 
</p>,
  },
  sgabf2023: {
    date: "Apr 2023",
    title: "Singapore Art Book Fair 2023",
    category: "Exhibition / Performance",
    status: "Completed",
		  overview: <p>Feelers teamed up with Singaporean theatre company Checkpoint Theatre to booth at Singapore Art Book fair for the very first time in 2023. <br /><br />

Feelers presented three original publications: Eco-tech toolkit ‘Greener Screens’, ‘Writing Machine’, a collection of works co-written with other tools, phenomena and intelligences and Feelers' manifesto, ‘How To Start, How To Go On’. Feelers also released a very limited number of clay pigeons and keychain tokens that could be used to attend the workshops Kinetic Birds and sketch2pigeon.</p>,
  },
  "how-to-start": {
    date: "Apr 2023",
    title: "How to Start, How to Go On",
    category: "Print",
    status: "Completed",
    image1: "/assets/how_to_start/how_to_start-1.webp",
		  overview: <p>How To Start, How To Go On is a collection of conversations, project lists, manifestos and essays that trace Feelers’ journey since its beginning in 2020. These speculative and silly works give a snapshot of Feelers’ vision as an art-tech label that is working towards a more sustainable, inhabitable and lively world. 
</p>,
  },
  "writing-machine-print": {
    date: "Apr 2023",
    title: "Writing Machine",
    category: "Print",
    status: "Completed",
    image1: "",
		  overview: <p> <b>Writing Machine</b> is an extension of a workshop Feelers conducted in early 2023, exploring the concept of authorship and co-writing with other tools, phenomena and intelligences. Turning to exercises that spanned the literary, computational and divinatory, Feelers’ Co-Founder and former Team Lead Ang Kia Yee engaged with authorship as inherently shared — with code, chance, constraints, divination, their subconscious, and other human beings.
		  </p>,
  },
  "greener-screens-print": {
    date: "Apr 2023",
    title: "Greener Screens",
    category: "Print",
    status: "Completed",
    image1: "/assets/greener_screens/greener_screens-4.webp",
    image2: "/assets/greener_screens/greener_screens-5.webp",
		  overview: <p><b>Greener Screens</b> is an eco-tech toolkit, laying out digital sustainability habits that individuals can use in their daily lives and personal practice. In an effort to make conversations around digital sustainability less daunting, the toolkit includes a mad lib green manifesto, and sticker sheet of eco tips to keep things playful.</p>,
  },
  "pecha-kucha": {
    date: "Mar 2023",
    title: "Pecha Kucha",
    category: "Event",
    status: "Completed",
		  overview: <p><b>PechaKucha</b>, in Japanese, actually means “chit-chat”. Feelers partnered with digital storytelling studio Tusitala to present a series of sharings from speakers using the PechaKucha 20 slides x 20 seconds format to present on a range of topics related to art, tech or both.<br /><br />

				  PechaKucha #1 (March 2023): Presentations covered the future of fashion design by Claudia Poh, the phenomena of the uncanny by Chok Sixuan, how to think about art and tech by Henrik Cheng, simplicity/complexity and 3D printing by Hui Yijian, and how AI can come together with Kathakali dance-drama by Ganesh Neelakanta.<br /><br />

				  PechaKucha #2 (June 2023): Presentations covered the use of eye tracking in user experience design by James Breeze, comparison between art and tech approaches by Julian Wong and speculative design and AR by Renee Wong. Simon Chesterman of AI Singapore spoke on whether we should trust AI, Kontinentalist Siti Aishah spoke on data storytelling and maps, and Syafiq Halid shared on intersection of Malay drums and electronic music.<br /><br />

PechaKucha #3 (August 2023): Audiovisual maker Lynette Quek shared about element of play within sound performance practices, Lecturer and education research scientist, Michael Tan made a case for dreaming, Architectural student, John Chew Geronimo Jr. spoke about how trees are represented in architecture, Syahiruddin, a full stack developer at River Valley Irregulars, shared his journey to becoming a self-resourced programmer, Actor and Cybersecurity & Digital Technology consultant, and Michael Chua shared his perspective on AI and film production. Finally, Totapo residents, Yifan Wang, Bui Nguyen Bao Anh, Srivang Srivastava, shared about their project to reimagine interactions with the blockchain. 
		  </p>,
  },
  "islands-residency": {
    date: "Mar 2023",
    title: "I_S_L_A_N_D_S Residency",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/islands_residency/islands_residency-1.webp",
    image2: "/assets/islands_residency/islands_residency-2.webp",
    image3: "/assets/islands_residency/islands_residency-3.webp",
		  overview: <p>From February-April 2023, Feelers was in residence at experimental art platform I_S_L_A_N_D_S with a programme series called Signal, not noise. Alongside free consultation drop-ins for Feelers' art, tech, and writing services, astrology readings, and an open studio, the team hosted mini-workshops, including: <br /><br />

				  – <b>Cybernetic Rituals For Right Now (CRFRN)</b>, a workshop where participants designed cybernetic rituals for themselves - for fun, joy, healing, and exploration.<br /><br />
				  – <i>Build Our Own Server (BOOS)</i> a workshop guiding participants through building a low power web server together to give islands their very own local network.<br /><br />
				  –<i>TLDR (Touch + Light, Determine Reaction)</i>, a workshop on how to build an interactive light circuit activated by touch.<br /><br />

		 </p>
,
  },
  "writing-machine-workshop-2023": {
    date: "Feb 2023",
    title: "Writing Machine",
    category: "Education",
    status: "Completed",
    image1: "/assets/writing_machine/writing_machine-2.webp",
    image2: "/assets/writing_machine/writing_machine-1.webp",
		  overview: <p><b>Writing Machine</b> is an extension of a workshop Feelers conducted in early 2023, exploring the concept of authorship and co-writing with other tools, phenomena and intelligences. Turning to exercises that spanned the literary, computational and divinatory, Ang Kia Yee engaged with authorship as inherently shared — with code, chance, constraints, divination, their subconscious, and other human beings.
		  </p>,
  },
  "generative-dreaming": {
    date: "Nov 2022",
    title: "Generative Dreaming",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/generative_dreaming/generative_dreaming-1.webp",
    image2: "/assets/generative_dreaming/generative_dreaming-2.webp",
		  overview: <p><b>Generative Dreaming</b> reaches toward other worlds and futures through conversations between young artists who are learning how to make, how to persist, and what they desire.<br /><br />

				  Season 1 gathers practitioners who work across performance, installation, sculpture, and digital media to explore intersections between their practices.<br /><br />

				  In each episode, two artists chat about what, why and how they make what they make, as well as their visions for the future and the wider world. Their conversations reveal how we persist through care, community and creative strategy – not just as artists, but also as people.<br /><br />

Taking a structured but meandering approach, the artists of each episode roam across various themes — such as audience, body politics, and glitching. They reach toward one another to see what emerges, what is possible where they touch.
</p>,
  },
  "good-am-to-you": {
    date: "Nov 2022",
    title: "Good AM To You",
    category: "Event",
    status: "Completed",
    image1: "/assets/good_am/good_am-1.webp",
    image2: "/assets/good_am/good_am-2.webp",
    image3: "/assets/good_am/good_am-3.webp",
    overview: `Colloquially-known “Good Morning” WhatsApp images are easily identified by their colourful, saturated stock backgrounds featuring positive daily tidings in mismatched fonts. For the National Library Board's LOLA (RE)CONNECT Series, Feelers created a “Good Morning” graphics generator and hosted a sharing by graphic designers Qing (OuterEdit), Iffah Dahiyah (Fellow), and Izyanti Asa'ari (Fellow) on their favourite “Good Morning” graphics.

`,
  },
  "through-the-neighbours-walls": {
    date: "Nov 2022",
    title: `Through The Neighbour's Walls`,
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/through_the_neighbours/through_the_neighbours-1.webp",
		  overview: <p>Feelers created an interactive rotary phone prop for Through the Neighbour's Walls, an experiential public installation which is an extension of the first episode of The Everyday Museum’s self-guided audio trail series, Speaking of which – An Organic Terminus.<br /><br />

				  Set in a living room from the past, a Rediffusion set broadcasted familiar programmes throughout the day, reliving its role as a companion to the worker and the homemaker, the young and the old. It alluded to a time when Rediffusion was woven into the fabric of our daily lives and served as a locus around which communities would gather.<br /><br />

				  When passers-by listened to the Rediffusion broadcasts, they were transported to a different time and space. Entering the living room took guests into the life of an imagined household where they would engage in intimate encounters. As they discovered traces left behind by family members, they were be invited to reflect upon and share their own fond memories of everyday pastimes.<br /><br />

				  This work was comissioned by The Everyday Museum in partnership with the National Archives of Singapore and with support from Rediffusion. Public interactions by Clarice Ng, set design and art direction by Junior Foong.<br /><br />

</p>,
  },
  "another-world-is-possible": {
    date: "Sep 2022",
    title: "Another World Is Possible",
    category: "Education",
    status: "Completed",
    image1: "/assets/another_world_is_possible/another_world_is_possible-1.webp",
		  overview: <p>Another World is Possible was a panel discussion at the National Library about the role of design and technology in building a more ethical and equitable world.<br /><br />

Panellists Saad Chinoy (SpudnikLab), Claudia Poh (Werable) and Wendy Wong (55 Minutes), spoke on the pressing need for designs and technologies which value and empower the autonomy and needs of their users, the deepening digital divide, the ongoing shift from Web 2.0 to Web 3.0, as well as various considerations in achieving empathetic and user-centred design.
</p>,
  },
  "greener-screens-2022": {
    date: "Sep 2022",
    title: "Greener Screens",
    category: "Education",
    status: "Completed",
    image1: "/assets/greener_screens/greener_screens-1.webp",
    image2: "/assets/greener_screens/greener_screens-2.webp",
    image3: "/assets/greener_screens/greener_screens-3.webp",
		  overview: <p>In Greener Screens, Ashley Hi shared resources on greener tech habits and guided participants through creative exercises to build a sustainable tech toolkit that is customised to the needs of their own business or personal practice.<br /><br />

The workshop covered actionable design steps for greater energy efficiency, existing digital tools that minimise energy consumption, as well as Feelers’ own eco experiments.
</p>,
  },
  "talk-touch": {
    date: "Aug 2022",
    title: "Talk Touch",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/talk_touch/talk_touch-1.webp",
    image2: "/assets/talk_touch/talk_touch-2.webp",
		  overview: <p>Feelers was matched with a team of five students for Singapore University of Technology and Design (SUTD)'s Capstone Design Programme. Over 7 months, Feelers mentored the Capstone team over a process of ideation, development and prototyping, where the students worked on the proposed idea of a haptic wearable.<br /><br />

This culminated in their capstone showcase, where they presented a prototype called TalkTouch. TalkTouch aims to enhance the experience of digital communication by providing real-time haptic feedback that bridges the gap of physical distance between loved ones, friends, and family. With a combination of a web application that communicates with a lightweight haptic backpack, wearers can experience the touch of a loved one even if they are oceans apart.
As the first-ever haptic device of its kind, TalkTouch has the potential to redefine remote communication and intimacy, with possible applications in the healthcare and arts industries.
		  </p>,
  },
  caterfeelers: {
    date: "Jun 2022",
    title: "Caterfeelers",
    category: "Education",
    status: "Completed",
    image1: "/assets/caterfeelers/caterfeelers-1.webp",
    image2: "/assets/caterfeelers/caterfeelers-2.webp",
    image3: "/assets/caterfeelers/caterfeelers-7.webp",
		  overview: <p><b>caterfeelers</b> is a kinetic jewelry brand by Feelers which melds electronics and jewelry into distinctive wearables. Its first collection, launched in 2022, was 4 o'clock ___________, consisting of:<br /><br />

				  – brrr: a gentle and imaginative blessing for city romps. Made with omamori and mizuhiki knots, brrr offered well wishes for protection, togetherness and connection in the metropolis.<br /><br />

				  – click-click: a low-res third eye for another point of view. Its camera centrepiece hung upon a string of flowers, and came with three acrylic filters – grape, ultramarine and neon yellow.<br /><br />

				  – swish: a versatile charm necklace-meets-evolved fidget spinner. swish came in a half-and-half design of wire and charms which could unhook and hook along the necklace. The mini fan was activated by the push of a button.<br /><br />

				  – flutter: a light-up mask chain with small LED companions on either side. Buttons could be pressed to delight friends, send morse code messages, and brighten urban days.</p>,
  },
  "kinetic-birds": {
    date: "May 2022",
    title: "Kinetic Birds",
    category: "Education",
    status: "Completed",
    image1: "/assets/kinetic_birds/kinetic_birds-1.webp",
    image2: "/assets/kinetic_birds/kinetic_birds-2.webp",
    overview: `In this hands-on workshop by Ashley Hi, participants could build and bring home their very own kinetic sculpture. Participants were given a guided introduction to Arduino + servo motors – how to connect and run them, load code to control the servo's speed/position, and work with external controls.
`,
  },
  "office-hands-edition": {
    date: "May 2022",
		  title: "Labs: Office: Hands Edition",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/labs_office_hands/labs_office_hands-1.webp",
		  overview: <p><b>Office: Hands Edition'</b>, a video work by Xafiér Yap, was inspired by the finger cramps and neck strains suffered by the artist at their desk job. The work was an experiment to understand the somatic relationship between the office employee and the laptop.<br /><br />

<b>'Office: Hands Edition'</b> depicts the human body conforming to objects of technology — one, with the laptop; and two, with the motion capture technology. Xafiér self-monitored their movements in the office. They found out that the sedentary body was stiff, tense and withheld. These movements were replicated in a motion capture studio. However— with any sort of technology— Xafiér’s body had to shift and exaggerate their movements in order to reproduce the same postures. The video is a result of this experiment. <br /><br />

				  <b>Office: Hands Edition</b> was a part of Feelers' Labs programme, which housed and supported projects that integrated performance and technology, with a focus on how liveness and audience experience could be remapped across digital, virtual and physical space.<br /><br />
		  </p>,
  },
  "streetlamp-107101": {
    date: "Mar 2022",
    title: "Tracing Latencies:  Streetlamp No. 107101",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/streetlamp/streetlamp-1.webp",
    image2: "/assets/streetlamp/streetlamp-2.webp",
		  overview: <p><b>Streetlamp No.</b>107101 was a responsive light installation which spoke to the heavy light pollution of our small city, which houses at least 107,100 streetlamps (as of 2017). By resisting our expectations of light, it was a meditation on relationships with visibility as inflected by personal and communal senses of safety, security, privacy and time. 

The work was created for Tracing Latencies, an exhibition by the Culture & Smart City Project, a multilateral and multidisciplinary collaborative initiative by EUNIC Singapore Cluster, supported by Goethe-Institut. The hybrid group exhibition was held from 3 March to 3 April 2022 at 136 GOETHE LAB, Singapore.</p>
,
  },
  "build-a-caifan": {
    date: "Nov 2021",
    title: "Build-A-Caifan",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/build_a_caifan/build_a_caifan-1.webp",
    image2: "/assets/build_a_caifan/build_a_caifan-2.webp",
		  overview: <p><b>Build-A-Caifan</b> was an imaginary online caifan stall which digitally replicated the experience of picking out dishes at a stall through clicking on food emojis. The dishes selected were reflected real-time as illustrations on a plate before being digitally "cooked" using machine learning to present a final, realistic-looking plate of piping-hot, ready-to-eat caifan.</p>
,
  },
  "painter-reviews-watercolour": {
    date: "Oct 2021",
    title: "Painter Reviews Watercolour Paints ",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/painter_reviews_watercolour/painter_reviews_watercolour-1.webp",
    overview: `We sat down with Mengju (@mengjuice) to learn about watercolour paints! Full video launches tomorrow at 8pm on YouTube and IG TV
`,
  },
  "peaceful-process": {
    date: "Aug 2021",
    title: "Peaceful Process / Making a Cup & Coaster",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/peaceful_process/peaceful_process-1.webp",
    overview: ``,
  },
  "labs-voices-in-a-room": {
    date: "Aug 2021",
    title: "Labs: voices in a room",
    category: "Print",
    status: "Completed",
    image1: "/assets/voices_in_a_room/voices_in_a_room-1.webp",
    image2: "/assets/voices_in_a_room/voices_in_a_room-2.webp",
    image3: "/assets/voices_in_a_room/voices_in_a_room-3.webp",
		  overview: <p><b>Voices in a Room</b> was a Feelers Labs performance project by ants chua, Ang Kia Yee, Chew Shaw En, Helen Cai, Rice Tan and txting teo. While the project initially started as an examination of language's possibilities in responding to and inhabiting times of crisis, current pressing griefs led them to dream collectively about the futures they wished to bring into being.<br /><br />

				  <b>Voices in a Room</b> was a part of Feelers' Labs programme, which housed and supported projects that integrated performance and technology, with a focus on how liveness and audience experience could be remapped across digital, virtual and physical space.<br /><br />


				  In June 2024, Feelers revisited <b>Voices in a Room</b> with a series of recordings on Spotify, spoken aloud by Ang Kia Yee, Ashley Hi, ants chua, Alysha Chandra and Louise Marie Lee, with sound design and editing by Ada Adhiyatma.
		  </p>
,
  },
  "labs-across-a-small-distance": {
    date: "Sep 2021",
    title: "Labs: Across a Small Distance",
    category: "Exhibition / Performance",
    status: "Completed",
    image1: "/assets/across_a_small_distance/across_a_small_distance-1.webp",
    image2: "/assets/across_a_small_distance/across_a_small_distance-2.webp",
		  overview: <p><b>Across a Small Distance</b> is a work-in-progress by Chew Shaw En & Jevon Chandra about the nature of landing, receiving and transmission. Through a sequence of movements and activities, the work explores the textures of communication in small settings: the things too near to touch, misunderstandings too slight to notice, tiny truths too inconvenient to say.
				  <br /><br />

<b>Across a Small Distance</b> was a part of Feelers' Labs programme, which housed and supported projects that integrated performance and technology, with a focus on how liveness and audience experience could be remapped across digital, virtual and physical space.
		  </p>,
  },
  "labs-souvenir": {
    date: "Aug 2021",
		  title: "Labs: Souvenir",
    category: "Research / Development",
    status: "Completed",
		  overview: <p><b>Souvenir</b> was an AR artwalk developed by Feelers and digital storytelling studio Tusitala, curated by Kirti Upadhyaya and featuring artists Hilary Yip, Nathanael Townsend and Ryan Benjamin Lee. The artists created site-specific AR artworks for the Jubilee Park playground within Fort Canning, which prompted the user to consider the natural and man-made elements of the playground environment.<br /><br />

				  <b>Souvenir</b> was a part of Feelers' Labs programme, which housed and supported projects that integrated performance and technology, with a focus on how liveness and audience experience could be remapped across digital, virtual and physical space.<br /><br /></p>
  },
  "labs-100-advertisements": {
    date: "Jul 2021",
    title: "Labs: 100 Advertisements - Now Online!",
    category: "Research / Development",
    status: "Completed",
    image1: "/assets/100_ads/100_ads-1.webp",
    image2: "/assets/100_ads/100_ads-2.webp",
		  overview: <p>The first ever Labs project (and therefore first ever Feelers project) was <b>100 Advertisements - Now Online! </b> by Eng Kai Er, a darkly humourous live virtual show about the pandemic, politics, and the artist's life as an international student in Germany.<br /><br />

				  <b> 100 Advertisements - Now Online! </b>  was a part of Feelers' Labs programme, which housed and supported projects that integrated performance and technology, with a focus on how liveness and audience experience could be remapped across digital, virtual and physical space.
		  </p>,
  },
};

export default Projects;
